import type { AppConfig } from './app.types';

export function isString(value: unknown): value is string {
	return typeof value === 'string';
}

export function isValidAppConfig(cfg: AppConfig): cfg is AppConfig {
	return (
		typeof cfg === 'object' &&
		typeof cfg.API_CONTENT_URL === 'string' &&
		typeof cfg.API_DIGITAL_SIGNATURE_URL === 'string' &&
		typeof cfg.API_URL === 'string' &&
		typeof cfg.APP_ENV === 'string' &&
		typeof cfg.IS_EMPLOYEE_WEB === 'boolean'
	);
}
